import React from "react";
import Image from "mui-image";
import CardMedia from "@mui/material/CardMedia";
import LinkOff from "@mui/icons-material/LinkOff";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").Url} props.url
 * @param {string} props.name
 */
export const ConventionLogo = ({ url, name }) => {
  if (!url) {
    return null;
  }

  return (
    <CardMedia
      component="img"
      sx={{ maxHeight: 200, objectFit: "contain" }}
      image={url}
      title={`Event logo for ${name}`}
    />
  );
};

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").Convention} props.convention
 * @param {number} [props.width]
 * @param {number} [props.height]
 */
export const ConventionLogoSquare = ({ convention, width = 32, height = 32 }) => {
  return (
    <Image
      alt={convention.name}
      src={convention.logoUrl}
      fit="contain"
      width={width}
      height={height}
      errorIcon={<LinkOff />}
    />
  );
};
